import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { EmployeeProfileService } from './employee-profile.service';
@Injectable({
  providedIn: 'root',
})
export class EmployeeProfileResolver {

  constructor(private employeeProfileService: EmployeeProfileService) {}

  resolve(route: ActivatedRouteSnapshot) {
    const companyId = route.paramMap.get('companyId') ?? '';
    const employeeId = route.paramMap.get('employeeId') ?? '';
    return this.employeeProfileService.getEmployeeProfile(employeeId, companyId);
  }
}
